import { tourKeys } from '../@utils/tourKeys'

export default function getBiSteps() {
    const k = tourKeys('bi')

    return [
        {
            target: '.page-title',
            contentKey: k.welcome,
            placement: 'bottom',
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            target: '.bi-briefing-card',
            contentKey: k.briefing,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.bi-dashboard-filters',
            contentKey: k.filters,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '[data-tour="bi-panel-parity-index"]',
            contentKey: k.kpiCards,
            placement: 'bottom',
        },
        {
            target: '[data-tour="bi-panel-evolution-chart"]',
            contentKey: k.evolution,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('[data-tour="bi-panel-win-match-lose"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '[data-tour="bi-panel-win-match-lose"]',
            contentKey: k.winMatchLose,
            placement: 'top',
        },
        {
            target: '[data-tour="bi-panel-wml-details"]',
            contentKey: k.wmlDetails,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('[data-tour="bi-panel-global-vision"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '[data-tour="bi-panel-global-vision"]',
            contentKey: k.globalVision,
            placement: 'top',
        },
        {
            target: '[data-tour="bi-panel-disparities-table"]',
            contentKey: k.disparities,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('[data-tour="bi-panel-revenue-at-risk"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '[data-tour="bi-panel-revenue-at-risk"]',
            contentKey: k.revenueAtRisk,
            placement: 'top',
            data: {
                beforeNext: () => {
                    // Cambia a la tab de Competencia si existe
                    const tabs = document.querySelectorAll('.bi-dashboard-tabs button')
                    if (tabs.length > 1) tabs[1].click()
                },
                delay: 600,
            },
        },
        {
            target: '[data-tour="bi-panel-competition-my-price"]',
            contentKey: k.competitionCards,
            placement: 'bottom',
            data: {
                beforeNext: () => document.querySelector('[data-tour="bi-panel-competition-chart"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '[data-tour="bi-panel-competition-chart"]',
            contentKey: k.competitionChart,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('[data-tour="bi-panel-competition-calendar"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '[data-tour="bi-panel-competition-calendar"]',
            contentKey: k.competitionCalendar,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('[data-tour="bi-panel-competition-ranking"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '[data-tour="bi-panel-competition-ranking"]',
            contentKey: k.competitionRanking,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('[data-tour="bi-panel-competition-table"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '[data-tour="bi-panel-competition-table"]',
            contentKey: k.competitionTable,
            placement: 'top',
        },
        {
            target: '.bi-guide-trigger',
            contentKey: k.guide,
            placement: 'left',
        },
    ]
}
